export default __webpack_public_path__ + "static/media/3in1_en_d.98c45602.svg";